import { render, staticRenderFns } from "./ThemeForm.vue?vue&type=template&id=5a2214d0&"
import script from "./ThemeForm.vue?vue&type=script&lang=js&"
export * from "./ThemeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports